<script setup lang="ts">
import { computed, watch } from "vue"
import { Link, usePage } from "@inertiajs/vue3"
import { setI18nLocale, supportedLocales, type Locale } from "@/i18n"
import type { SharedProps } from "@/types"

const page = usePage<SharedProps>()
const currentLocale = computed(() => page.props.locale)

const localeHref = (locale: Locale) => {
  const url = new URL(page.url, window.location.origin)
  url.searchParams.set("locale", locale)
  return `${url.pathname}${url.search}`
}

watch(currentLocale, setI18nLocale, { immediate: true })
</script>

<template>
  <div class="flex items-center gap-2 text-sm font-semibold">
    <template v-for="(locale, index) in supportedLocales" :key="locale">
      <span v-if="index > 0" class="text-gray-300">/</span>

      <span
        v-if="currentLocale === locale"
        class="text-gray-400"
        aria-current="true"
      >
        {{ locale.toUpperCase() }}
      </span>
      <Link v-else :href="localeHref(locale)" class="hover:underline">
        {{ locale.toUpperCase() }}
      </Link>
    </template>
  </div>
</template>
